export default __webpack_public_path__ + "static/media/datepicker-arrow-right.c0fda977.svg";